import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { TimePill } from '../shared/TimePill';
import { secondsToTimeDurationString } from '../../utils/time';
import './TimeDuration.scss';

const ONE_TENTH_HOUR = 360; // equal to 0.10 hours in seconds

export const TimeDuration = ({ onChange, durationValue }) => {
  const durationFormat = useSelector((state) => state.time.config.settings?.durationFormat);

  // regular expressions taken directly from pattern matching used in time & billing
  const durationFormatRegExp = durationFormat === 'hh:mm:ss' ? RegExp('^(\\d{2,}):([0-5]\\d):([0-5]\\d)$') :
    durationFormat === 'hh:mm' ? RegExp('^(\\d{2,}):([0-5]\\d)$') :
      RegExp('^(\\d{1,})[.](\\d{2})$');

  const timeDurationStringToSeconds = (value) => {
    const matchedDuration = durationFormatRegExp.exec(value);
    let totalSeconds = 0;

    if (matchedDuration) {
      if (durationFormat === 'hh:mm:ss') {
        const hours = parseInt(matchedDuration[1]);
        const minutes = parseInt(matchedDuration[2]);
        const seconds = parseInt(matchedDuration[3]);
        totalSeconds = hours * 3600 + minutes * 60 + seconds;
      } else if (durationFormat === 'hh:mm') {
        const hours = parseInt(matchedDuration[1]);
        const minutes = parseInt(matchedDuration[2]);
        totalSeconds = hours * 3600 + minutes * 60;
      } else if (durationFormat === 'Hour Decimal') {
        const hours = parseInt(matchedDuration[1]);
        const minutesDecimal = parseFloat('0.' + matchedDuration[2]);
        const minutes = Math.round(minutesDecimal * 60);
        totalSeconds = hours * 3600 + minutes * 60;
      }
    }
    return totalSeconds;
  };

  const changeTimeWithTimePill = (value) => {
    const timeDurationAsSeconds = timeDurationStringToSeconds(time) + (ONE_TENTH_HOUR * value);
    const timeDurationAsString = secondsToTimeDurationString(timeDurationAsSeconds, durationFormat);
    setTime(timeDurationAsString);
    onChange(timeDurationAsSeconds);
  };

  const [time, setTime] = useState(durationValue ? secondsToTimeDurationString(durationValue, durationFormat) :
    durationFormat === 'hh:mm:ss' ? '00:06:00' :
      durationFormat === 'hh:mm' ? '00:06' :
        '0.10');

  return (
    <div className="TimeDuration">
      <TimePill value="-1.0" callback={() => changeTimeWithTimePill(-10)} />
      <TimePill value="-0.5" callback={() => changeTimeWithTimePill(-5)} />
      <TimePill value="-0.1" callback={() => changeTimeWithTimePill(-1)} />
      <div className='TimeDuration-container'>
        <label className='Label'>Duration</label>
        <input
          className={`TimeDuration-container-value`}
          type='text'
          onChange={(e) => {
            setTime(e.target.value);
          }}
          onBlur={(_) => {
            const timeDurationAsSeconds = timeDurationStringToSeconds(time);
            const timeDurationAsString = secondsToTimeDurationString(timeDurationAsSeconds, durationFormat);
            setTime(timeDurationAsString);
            onChange(timeDurationAsSeconds);
          }}
          value={time}
        />
      </div>
      <TimePill value="+0.1" callback={() => changeTimeWithTimePill(1)} />
      <TimePill value="+0.5" callback={() => changeTimeWithTimePill(5)} />
      <TimePill value="+1.0" callback={() => changeTimeWithTimePill(10)} />
    </div>
  );
};

TimeDuration.propTypes = {
  durationValue: PropTypes.number,
  onChange: PropTypes.func,
};
